<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    :config="config"
    ref="table"
  >
    <template #FREIGHT="{ visible, params, close }">
      <BillDetails :row="params.row" :close="close" v-if="visible" />
    </template>
    <template #CNB="{ visible, params }">
      <div v-if="visible">
        <Tag
          @click.native="copy(t)"
          style="margin-right: 5px"
          color="green"
          v-for="t in params.unpack_order"
          :key="t"
          >{{ t }}</Tag
        >
      </div>
    </template>
    <template #footer_bottom>
      <div
        style="font-size: 10px; color: rgb(204, 185, 185); text-align: right"
      >
        {{ $t("b2bDetailTip") }}
      </div>
    </template>
  </cTable>
</template>

<script>
import {
  getB2BDetails,
  exportB2BDetails,
  createB2Bbill,
  getB2Bbill,
  syncB2Bbill,
  getB2BbillSplit,
  getB2BbillSplitDetail,
  getRate,
  saveRate,
  getMultiRate,
  saveMultiRate,
  uploadFile,
  preview,
} from "@/api/finance/b2b_details_hq1";
import { getConfig } from "@/api/double/bill_hq";
import { getCountry } from "@/api/system/country";
import { getB2bBillUSer } from "@/api/double/bill";
import { getService, fordel, getServiceDetail } from "@/api/double/list";
import { getUser } from "@/api/user/internal";
import expandRow from "./template/index";
import cTable from "@/base/common/index";
import BillDetails from "./details";
import copyClick from "@/utils/copyClick";
import { getSelectType, getKeysType } from "@/api/public";
import {getCompanies, searchClient} from "@/api/user/client";
import { client_hq } from "@/api/finance/shipment_hq";
import { useModal } from "../b2b_bill_hq/rate.js";
export default {
  name: "b2b_details_hq",
  components: {
    cTable,
    BillDetails,
  },
  async mounted() {
    console.clear()
    console.log('xxx2')
    let salesman = (await getUser({ standard: "Salesman" })).data.payload.rows;
    let consignee = (await getService()).data.payload;
    let fromCountry = (await getCountry({ allow_depart: 1 })).data.payload.rows;
    let toCountry = (await getCountry({ allow_arrive: 1 })).data.payload.rows;
    // this.client_hq_list = (await client_hq()).data.payload;
    let data = (await getConfig()).data.payload;
    this.$refs["table"].currency = data.currency;
    this.header.searchs.forEach((item) => {
      if (item.key === "from_country") item.options = fromCountry;
      if (item.key === "to_country") item.options = toCountry;
      if (item.key === "consignee") item.options = consignee;
      if (item.key === "seller") item.options = salesman;
      // if (item.key === "hq_client") item.options = this.client_hq_list;
    });
  },
  methods: {
    copy(t) {
      copyClick.copyToClipboard(t, this);
    },
  },
  data() {
    return {
      client_hq_list: [],
      hq_clients: [],
      config: {
        children: true,
        rowId: "id",
        expandConfig: {
          accordion: true,
          lazy: true,
          visibleMethod: ({ row }) => {
            if (row.is_unpack === "YES") return true;
          },
          loadMethod({ row }) {
            return new Promise((resolve) => {
              let data = {
                packing_number: row.packing,
                airway_number: row.airway_bill_number,
              };
              getB2BbillSplitDetail(data).then((res) => {
                console.log(res);
                row["expand"] = res.data.status ? res.data.payload : [];
                resolve(row);
              });
            });
          },
        },
      },
      methods: {
        list: (data) => {
          let params = JSON.parse(JSON.stringify(data));
          if (data.hq_client) {
            // params.hq_client = this.client_hq_list.reduce((a, b) => {
            //   this.hq_clients.find((t) => {
            //     if (t.value === b.uuid && t.label === b.account) {
            //       a.push(b);
            //       return true;
            //     }
            //   });
            //   return a;
            // }, []);
          }
          return getB2BDetails(params);
        },
        getB2bBillUSer,
        exportB2BDetails,
        createB2Bbill,
        syncB2Bbill,
        getServiceDetail,
        getB2BbillSplit,
        getRate,
        b2bReStatistics: saveRate,
        getMultiRate,
        saveMultiRate,
        uploadFile,
        preview,
        fordel,
      },
      modals: {
        quantity: {
          config: {
            title: this.$tz(""),
            modalBind: {
              width: 1000,
            },
          },
          footer: {
            show: () => false,
          },
          header: {
            show: () => true,
            btns: [
              {
                name: () => this.$tz("导出"),
                type: "export",
                fnName: "export",
                bind: {
                  type: "primary",
                },
              },
            ],
            methods: {
              export() {
                this.$page.exportExc({
                  fields: this.table.fields,
                  data: this.list,
                });
              },
            },
          },
          table: {
            config: {
              height: 600,
            },
            fields: [
              {
                name: () => this.$tz("订单号码"),
                key: "airway_number",
                minWidth: 110,
                header: {
                  copy: true,
                },
                copy: true,
              },
              {
                name: () => this.$tz("申明重量"),
                key: "claim_weight",
                minWidth: 110,
              },
              {
                name: () => this.$tz("入库重量"),
                key: "check_weight",
                minWidth: 110,
              },
              {
                name: () => this.$tz("申报价值"),
                key: "values",
                minWidth: 110,
              },
            ],
          },
        },
        bill: {
          config: {
            modalBind: {
              width: 1200,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
          fields: [],
          table: {
            config: {
              height: 600,
            },
            footer: {
              show: true,
            },
            fields: [
              {
                name: () => this.$t("order_number"),
                key: "airway_number",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("order_userRef"),
                key: "source_no",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("country_t"),
                key: "country",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("CTNS"),
                key: "quantity ",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("actual_weight"),
                key: "actual_weight",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("charge_volume"),
                key: "volume_weight",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("skuVolume"),
                key: "volume",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("charge_params1"),
                key: "charging_weight",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("charging_volume"),
                key: "charging_volume",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("company"),
                key: "service",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("quoteDetails"),
                key: "detail",
                tooltip: true,
                minWidth: 100,
              },
            ],
          },
        },
        upload: {
          methods: {
            ok() {
              window.open(this.$globalUrl + "/excel/tmp/B2bBranchFeesTpl.xlsx");
            },
          },
          footer: {
            cancel: {
              isShow: true,
            },
            ok: {
              name: this.$t("download_tem"),
            },
          },
          config: {
            modalBind: {
              width: 500,
              draggable: true,
              maskClosable: false,
            },
            rowBind: {
              gutter: 16,
              // style: {
              //   marginBottom: "20px"
              // }
            },
            title: this.$t("upload") + this.$t("files"),
          },
          grid: [{ files: 24 }],
          fields: [
            {
              key: "files",
              component: "Upload",
              bind: {
                type: "drag",
                accept: ".xlsx",
              },
              methods: {
                beforeUpload: ({ file }) => {
                  let formData = new FormData();
                  formData.append("file", file); // 文件对象
                  let _this = this.$refs["table"];
                  _this
                    .handleRequestMethods("uploadFile", formData)
                    .then((res) => {
                      _this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      _this.getModal("upload").close();
                    });
                  return false;
                },
              },
            },
          ],
        },
        rate: useModal.call(this, "b2b_details_hq"),
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.shipment_id = this.$page.selectAll.map(
                (item) => item.shipment_id
              );
              this.$page
                .handleRequestMethods("createB2Bbill", data)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$t("createBill"),
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          grid: [{ name: 24 }],
          fields: [
            {
              name: this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme"),
            },
          ],
        },
        hang: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.airway_number = this.$page.selectAll.map((item) => {
                return item.airway_bill_number;
              });
              this.$page.handleRequestMethods("hang", data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            title: this.$t("hang"),
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              remarks: [
                {
                  required: true,
                  message: "Please Enter name",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ remarks: 24 }],
          fields: [
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                rows: 5,
                type: "textarea",
              },
            },
            // {
            //   name: this.$t("Remarks"),
            //   key: "remarks",
            //   component: "Input",
            //   placeholder: () => this.$t("enter") + this.$t("Remarks")
            // },
            // {
            //   name: this.$t("type"),
            //   key: "types",
            //   component: "Radio",
            //   options: [
            //     { label: "总部", value: 1 },
            //     { label: "分公司", value: 2 },
            //     { label: "部门", value: 3 },
            //     { label: "岗位", value: 4 }
            //   ],
            //   bind: {
            //     border: true
            //   }
            // }
          ],
        },
        showCNB: {
          contentSlot: "CNB",
          config: {
            title: this.$t("CNBOrder"),
            modalBind: {
              width: 750,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
              styles: {
                top: "30px",
              },
            },
            modalContentBind: {
              style: {
                minHeight: "500px",
              },
            },
          },
          methods: {
            // cancel() {
            //   this.$page.getList();
            // }
          },
          header: {
            show: () => true,
            copy: true,
            methods: {
              copy({ row }) {
                copyClick.copyToClipboard(row.unpack_order.join("\n"), this);
              },
            },
          },
          footer: {
            show: () => false,
          },
        },
        showFreight: {
          contentSlot: "FREIGHT",
          config: {
            modalBind: {
              width: 1550,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
              styles: {
                top: "30px",
              },
            },
          },
          methods: {
            // cancel() {
            //   this.$page.getList();
            // }
          },
          header: {
            show: () => true,
            copy: true,
            methods: {
              copy({ row }) {
                console.log(row);
                copyClick.copyToClipboard(row.airway_number, this);
              },
            },
          },
          footer: {
            show: () => false,
          },
          table: {
            height: 500,
          },
        },
        showUnPack: {
          config: {
            listFn: "getB2BbillSplit",
            modalBind: {
              width: 600,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
          fields: [],
          table: {
            config: {
              height: 600,
            },
            footer: {
              show: true,
            },
            fields: [
              {
                name: () => this.$t("order_number"),
                key: "airway_number",
                tooltip: true,
                minWidth: 100,
              },
            ],
          },
        },
        ortherCostList: {
          config: {
            modalBind: {
              width: 60,
            },
            title: "order_desc",
            modalContentBind: {
              style: "height:60vh;overflow-x:hidden;overflow-y:auto;",
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
          fields: [],
          table: {
            config: {
              align: "center",
              height: 500,
            },
            fields: [
              {
                name: () => this.$t("valueService") + this.$t("alipay_name"),
                key: "service_name",
                minWidth: 100,
              },
              {
                name: () => this.$t("Billing") + this.$t("noofpieces"),
                key: "quantity",
                align: "center",
                width: 100,
              },
              {
                name: () => this.$t("valueService") + this.$t("cost_t"),
                key: "total_amount",
                align: "center",
                width: 110,
              },
              {
                name: () => this.$t("operate"),
                key: "create_name",
                align: "center",
                width: 100,
              },
              {
                name: () => this.$t("operation") + this.$t("time"),
                key: "create_time",
                align: "center",
                width: 150,
              },
            ],
          },
        },
      },
      footer: { show: () => true },
      header: {
        searchs: [
          {
            key: "time_type",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            component: "Select",
            options: [
              { label: this.$t("outboundTime"), value: 1 },
              { label: this.$t("inboundTime"), value: 2 },
              { label: this.$t("InletTime"), value: 3 },
              { label: this.$t("finances") + this.$t("date"), value: 4 },
              { label: "POD" + this.$t("time"), value: 5 },
            ],
            default: 1,
          },
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              type: "date",
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              type: "date",
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "target_type",
            component: "Select",
            placeholder: () => this.$t("select") + this.$t("CollectionUser"),
            clearable: true,
            options: [
              { label: this.$t("b2bClient"), value: 1 },
              { label: this.$t("branchOffice"), value: 2 },
            ],
          },
          {
            key: "hq_client",
            component: "SelectSearchable",
            placeholder() {
              return this.$t("select") + this.$t("HQClient");
            },
            clearable: true,
            options: [],
            config: {
              label: "account",
              value: "id",
            },
            filterable: true,
            methods: {
              "remote-method"({field, formData}, $event) {
                if ($event.length >= 2) {
                  searchClient({keywords: $event}).then(res => {
                    field.options = res.data.payload.rows
                  })
                }
              },
            }
          },
          {
            key: "from_country",
            placeholder() {
              return this.$t("select") + this.$t("from_country");
            },
            component: "Select",
            options: [],
            config: {
              label: "code",
              value: "code",
            },
          },
          {
            key: "to_country",
            placeholder() {
              return this.$t("select") + this.$t("allow_arrive");
            },
            component: "Select",
            options: [],
            config: {
              label: "code",
              value: "code",
            },
          },
          {
            key: "seller",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            component: "Select",
            options: [],
            config: {
              label({ row }) {
                return row.realname
                  ? row.account + "(" + row.realname + ")"
                  : row.account;
              },
              value: "id",
            },
          },
          {
            key: "consignee",
            placeholder() {
              return this.$t("select") + this.$t(this.$t("company"));
            },
            component: "Select",
            options: [],
            config: {
              label: "service_name",
              value: "service_code",
            },
          },
          {
            key: "finance",
            placeholder() {
              return this.$t("whether") + this.$t("bindFreight");
            },
            component: "Select",
            options: [
              {
                label: this.$t("YES"),
                value: "YES",
              },
              {
                label: this.$t("NO"),
                value: "NO",
              },
            ],
          },
          {
            key: "isUnpack",
            placeholder() {
              return this.$t("whether") + this.$t("unpack");
            },
            component: "Select",
            options: [
              {
                label: this.$t("YES"),
                value: "YES",
              },
              {
                label: this.$t("NO"),
                value: "NO",
              },
            ],
          },
          {
            key: "is_create",
            placeholder() {
              return this.$t("whether") + this.$t("isOrder");
            },
            component: "Select",
            options: [
              {
                label: this.$t("YES"),
                value: "YES",
              },
              {
                label: this.$t("NO"),
                value: "NO",
              },
            ],
          },
          {
            key: "main_contract_header",
            placeholder() {
              return this.$t("select") + this.$t("preferential");
            },
            component: "Select",
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getB2Bbill()).data.payload;
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "department",
            placeholder() {
              return this.$t("select") + this.$t("assistDepartment");
            },
            component: "Select",
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["CLEARANCE_DEPARTMENT"])).data
                  .payload["CLEARANCE_DEPARTMENT"];
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "keywordsType",
            placeholder() {
              return this.$t("select") + this.$t("keyword") + this.$t("type");
            },
            component: "Select",
            config: {
              label({ row }) {
                return this.$t(row.label);
              },
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getKeysType("B2B_OUTBOUND_KEYWORDS")).data
                  .payload;
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("createBill"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning",
              },
              // id: 777,
            },
            {
              name: () => this.$t("synchronous"),
              type: "synchronous",
              fnName: "synchronousFn",
              bind: {
                icon: "md-refresh",
                type: "success",
              },
            },

            // {
            //   name: () => this.$t("hang"),
            //   type: "hang",
            //   fnName: "hang",
            //   disabled() {
            //     return !this.selectAll.length;
            //   },
            //   bind: {
            //     // icon: "md-checkmark",
            //     type: "error"
            //   }
            // },
            // {
            //   name: () => this.$t("cancel") + this.$t("hang"),
            //   type: "cancelHang",
            //   fnName: "cancelHang",
            //   disabled() {
            //     return !this.selectAll.length;
            //   },
            //   bind: {
            //     // icon: "md-checkmark",
            //     type: "error"
            //   }
            // },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                // icon: "md-arrow-down",
                type: "primary",
              },
              // id: 778,
              // list: [
              //   {
              //     name: "B2B" + this.$t("out") + this.$t("information"),
              //     type: "1",
              //     fnName: "export",
              //     bind: {
              //       icon: "md-arrow-down",
              //       type: "primary",
              //     },
              //   },
              //   {
              //     name:
              //       "B2B" +
              //       this.$t("out") +
              //       this.$t("information") +
              //       "+" +
              //       this.$t(" unpack") +
              //       this.$t("information"),
              //     type: "2",
              //     fnName: "export",
              //     bind: {
              //       icon: "md-arrow-down",
              //       type: "primary",
              //     },
              //   },
              // ],
            },
            {
              name: () => this.$t("batch") + this.$t("rate"),
              type: "rate",
              fnName: "rate",
              bind: {
                type: "warning",
              },
              disabled() {
                return !this.selectAll.length;
              },
            },
            {
              name: () =>
                this.$t("branchOffice") +
                this.$t("bindFreight") +
                this.$t("import"),
              type: "upload",
              fnName: "upload",
              bind: {
                type: "warning",
              },
            },
          ],
          methods: {
            upload() {
              this.getModal("upload").open();
            },
            rate({ row }) {
              let ids = this.selectAll.map((t) => t.id);
              this.handleRequestMethods("getMultiRate", { ids }).then((res) => {
                console.log(res, "res");
                let rules = {
                  USD: [],
                  CNY: [],
                  SAR: [],
                  AED: [],
                  QAR: [],
                  KWD: [],
                };
                if (!Array.isArray(res.payload.curren_amount)) {
                  Object.keys(res.payload.curren_amount).map(
                    (t) =>
                      (rules[t] = [
                        {
                          required: true,
                          type: "number",
                          message: "cannot be empty",
                          trigger: "blur",
                        },
                        {
                          required: true,
                          type: "number",
                          message: "cannot less than 0.0001",
                          trigger: "blur",
                          min: 0.0001,
                          max: 999999,
                        },
                      ])
                  );
                }
                Object.assign(this.modals.rate.config.rules || {}, rules);
                this.getModal("rate").open(
                  { ...res.payload.rate, ids, fn: "saveMultiRate" },
                  function () {
                    this.setTitle(this.$t("batch") + this.$t("rate"));
                  }
                );
              });
            },
            export({ searchForm, field }) {
              this.exportExc();
              /* let params = JSON.parse(JSON.stringify(searchForm));
              if (params.hq_client) {
                params.hq_client = this.client_hq_list.reduce((a, b) => {
                  this.hq_clients.find((t) => {
                    if (t.value === b.uuid && t.label === b.account) {
                      a.push(b);
                      return true;
                    }
                  });
                  return a;
                }, []);
              }
							let table =this.$refs['table']
              params["export"] = field.type;
              table.openLoading();
              table.handleRequestMethods(
                "exportB2BDetails",
                params,
                true,
                true
              ).then((res) => {
                window.open(this.$globalUrl + res.payload);
              }); */
            },
            add: ({ searchForm }) => {
              let params = JSON.parse(JSON.stringify(searchForm));
              if (params.hq_client) {
                params.hq_client = this.client_hq_list.reduce((a, b) => {
                  this.hq_clients.find((t) => {
                    if (t.value === b.uuid && t.label === b.account) {
                      a.push(b);
                      return true;
                    }
                  });
                  return a;
                }, []);
              }
              this.$refs["table"].getModal("add").open(params);
            },
            hang() {
              this.getModal("hang").open();
            },
            cancelHang() {
              let data = {
                ids: this.selectAll.map((item) => item.id),
              };
              this.$Modal.confirm({
                title: this.$t("cancel") + this.$t("hang"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("cancelHangStatus", data).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
            synchronousFn() {
              this.$Modal.confirm({
                title: this.$t("synchronous"),
                width: 300,
                content:
                  this.$t("whether") +
                  this.$t("confirmOrder") +
                  this.$t("synchronous") +
                  "?",
                onOk: () => {
                  this.handleRequestMethods("syncB2Bbill", null, true).then(
                    (res) => {
                      this.getList();
                    }
                  );
                },
              });
            },
          },
        },
      },
      fields: [
        {
          width: 35,
          type: "expand",
          showOverflow: false,
          fixed: "left",
          expandRender: (h, p) => {
            return h(expandRow, {
              props: {
                row: p.row.expand,
              },
            });
          },
          fnName: "expandFun",
          methods: {
            expandFun({ row }) {
              console.log(row);
              return row.id;
            },
          },
        },
        {
          type: "checkbox",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("finances") + this.$t("date"),
          key: "finance_time",
          minWidth: 130,
        },
        {
          name: () => this.$t("salesman"),
          align: "left",
          key: "sale_name",
          width: 150,
        },
        {
          name: () => this.$t("assistDepartment"),
          minWidth: 100,
          key: "department",
        },
        {
          name: () => this.$t(this.$t("company")),
          align: "left",
          minWidth: 100,
          key: "consignee",
        },
        {
          name: () => this.$t("fs_name"),
          key: "fs",
          align: "center",
          width: 110
        },
        {
          name: () => this.$t("preferential"),
          align: "left",
          minWidth: 100,
          key: "main_contract_header_txt",
        },
        {
          name: () => this.$t("ownership"),
          align: "left",
          minWidth: 100,
          key: "ownership_name",
        },
        {
          name: () => this.$t("dingcangCompany"),
          align: "left",
          minWidth: 100,
          key: "dingcang_company",
        },
        {
          name: () => this.$t("CollectionUser"),
          align: "center",
          key: "target_type_txt",
          minWidth: 100,
          bind: {
            style({ row }) {
              if (row.target_type === 2) {
                return { color: "red" };
              }
            },
          },
        },
        {
          name: () => this.$t("ClientCode"),
          key: "client_name",
          align: "left",
          minWidth: 100,
        },
        {
          name: () => this.$t("ClientCNFullName"),
          key: "shipper_company",
          align: "left",
          minWidth: 140,
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_bill_number",
          // component: "Button",
          width: 150,
          bind: {
            type: "primary",
            size: "small",
          },
          copy: true,
          // methods: {
          //   render({ h, row }) {
          //     return row.airway_bill_number;
          //   },
          //   // click({ row }) {
          //   //   this.$page
          //   //     .getModal("showDetails")
          //   //     .setTitle(row.check_bill_number);
          //   //   // this.getModal("writeOff").type = "writeOff";
          //   //   this.$page.getModal("showDetails").open({ row });
          //   // }
          // },
        },
        {
          name: () => this.$t("referCode"),
          key: "client_refer_code",
          align: "left",
          minWidth: 100,
        },
        {
          name: () => this.$t("tracker_code"),
          key: "trace_status",
          width: 80,
        },
        {
          name: () => this.$t("tracker_time"),
          key: "trace_time",
          width: 80,
        },
        {
          name: () => this.$t("track_title"),
          key: "trace_remarks",
          width: 150,
        },
        {
          name: () => this.$t("status_location"),
          key: "trace_address",
          width: 150,
        },
        {
          name: () => this.$t("from_country"),

          key: "from_country",
          width: 80,
        },
        {
          name: () => this.$t("target_country"),
          key: "to_country",
          width: 80,
        },
        {
          name: () => this.$t("city_name"),
          key: "city_name",
          width: 80,
        },
        {
          name: () => this.$t("to_station"),
          key: "warehouse",
          width: 80,
        },
        {
          name: () => this.$t("productName"),
          key: "goods",
          width: 80,
        },
        {
          name: () => this.$t("pretendNumber"),
          key: "quantity",
          width: 110,
          component: ({ row }) => {
            return row.data_type == 2 ? "Button" : "span";
          },
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            click({ row }) {
              row.data_type == 2 &&
                this.$page
                  .handleRequestMethods(
                    "fordel",
                    { airway_number: row.airway_bill_number },
                    false,
                    true
                  )
                  .then((res) => {
                    this.$page.getModal("quantity").open({ row }, function () {
                      this.setTitle(row.airway_bill_number);
                      this.list = res.payload;
                    });
                  });
            },
          },
        },
        {
          name: () => this.$t("values"),
          minWidth: 100,
          key: "values",
        },
        {
          name: () => this.$t("actual_weight") + "KG",
          key: "actual_weight",
          minWidth: 100,
        },
        {
          name: () => this.$t("skuVolume") + "CBM",
          key: "charge_volume",
          minWidth: 100,
        },
        {
          name: () => this.$t("charge_params") + "KG",
          key: "charge_weight",
          minWidth: 100,
        },
        {
          name: () => this.$t("charge_volume") + "KG",
          key: "volume_weight",
          minWidth: 100,
        },
        {
          name: () => this.$t("price_t") + this.$t("Remarks"),
          key: "amount_remarks",
          minWidth: 200,
        },
        {
          name: () => this.$t("QuotationRemarks"),
          key: "sale_remarks",
          minWidth: 200,
        },
        {
          name: () => this.$t("coll") + this.$t("reChAmount"),
          key: "cod_amount",
          minWidth: 100,
        },
        {
          name: () => this.$t("to") + this.$t("rate"),
          children: [
            {
              name: () => this.$t("toCurrency"),
              key: "target_currency",
              minWidth: 100,
            },
            {
              name: () => "CNY",
              key: "cny_to_rate",
              minWidth: 100,
            },
            {
              name: () => "USD",
              key: "usd_to_rate",
              minWidth: 100,
            },
            {
              name: () => "QAR",
              key: "qar_to_rate",
              minWidth: 100,
            },
            {
              name: () => "KWD",
              key: "kwd_to_rate",
              minWidth: 100,
            },
            {
              name: () => "AED",
              key: "aed_to_rate",
              minWidth: 100,
            },
            {
              name: () => "SAR",
              key: "sar_to_rate",
              minWidth: 100,
            },
          ],
        },
        {
          name: () => this.$t("firstFee"),
          children: [
            {
              name: () => this.$t("AirOrSeaFreight"),
              key: "feeList.freight",
              minWidth: 100,
            },
            {
              name: () => this.$t("insurance_fee"),
              key: "feeList.bao_xian",
              minWidth: 100,
            },
            {
              name: () => this.$t("VATFee"),
              key: "feeList.vat",
              minWidth: 100,
            },
            {
              name: () => this.$t("documentsFee"),
              key: "feeList.dz_fee",
              minWidth: 100,
            },
          ],
        },
        {
          name: () => this.$t("endTripFee1"),
          children: [
            {
              name: () => this.$t("coll") + this.$t("HandlingFee"),
              key: "cod_handlefee",
              minWidth: 100,
            },
            {
              name: () => this.$t("deliveryCost_t"),
              key: "feeList.deliver_fee",
              minWidth: 100,
            },
            {
              name: () => this.$t("Stevedorage"),
              key: "feeList.zx_fee",
              minWidth: 100,
            },
            {
              name: () => this.$t("TransferFee"),
              key: "feeList.zy_fee",
              minWidth: 100,
            },
            {
              name: () => this.$t("up") + this.$t("extra_charge"),
              key: "feeList.sjo_fee",
              minWidth: 100,
            },
            {
              name: () => this.$t("TrailerOrForkliftFee"),
              key: "feeList.xche_fee",
              minWidth: 130,
            },
            {
              name: () => this.$t("otherCost"),
              key: "feeList.other_fee",
              minWidth: 100,
            },
          ],
        },
        {
          name: () => this.$t("receivable_expenses"),
          children: [
            {
              name: () => "CNY",
              key: "target_total_amount_cny",
              minWidth: 100,
            },
            {
              name: () => "USD",
              key: "target_total_amount_usd",
              minWidth: 100,
            },
            {
              name: () => "QAR",
              key: "target_total_amount_qar",
              minWidth: 100,
            },
            {
              name: () => "KWD",
              key: "target_total_amount_kwd",
              minWidth: 100,
            },
            {
              name: () => "AED",
              key: "target_total_amount_aed",
              minWidth: 100,
            },
            {
              name: () => "SAR",
              key: "target_total_amount_sar",
              minWidth: 100,
            },
          ],
        },
        {
          name: () => this.$t("bill_type"),
          key: "status_name",
          width: 80,
        },
        {
          name: () => this.$t("bill_name"),
          key: "bill_name",
          width: 80,
          component: "a",
          methods: {
            click({ row }) {
              this.$router.push({
                name: "b2b_bill_hq",
              });
              this.$store.dispatch("pageUrl", row.bill_name);
            },
          },
        },
        {
          name: () => this.$t("ReconciliationUserName"),
          key: "bill_staff",
          width: 80,
        },
        {
          name: () => this.$t("PackShipmentNumber"),
          key: "str8",
          width: 80,
        },
        {
          name: () => this.$t("deliver_goods_number"),
          key: "deliver_number",
          width: 80,
        },
        {
          name: () => this.$t("b2boutbound_number"),
          key: "outbound_number",
          width: 80,
        },
        {
          name: () => this.$t("customsBill"),
          key: "packing",

          minWidth: 100,
        },
        {
          name: () => this.$t("method_name"),
          key: "transport_code",
          width: 80,
        },
        {
          name: () => this.$t("valueService"),
          key: "extend_finance",
          width: 110,
        },
        {
          name: () => this.$t("shipmentAgency"),
          key: "delivery_agent_name",
          width: 110,
        },
        {
          name: () => this.$t("warehouseName"),
          key: "warehouse_name",
          width: 80,
        },
        {
          name: () => this.$t("battery"),
          key: "battery_txt",
          width: 80,
        },
        {
          name: () => this.$t("is_solely"),
          key: "is_solely_txt",
          width: 80,
        },
        {
          name: () => this.$t("safetyService"),
          key: "safe_txt",
          width: 80,
        },
        {
          name: () => this.$t("ECommerChannel"),
          key: "transport_code_txt",
          width: 80,
        },
        {
          name: () => this.$t("special_remark"),
          key: "finance_remarks",
          width: 120,
        },
        {
          name: () => this.$t("OutboundRemarks"),
          key: "outbound_remarks",
          width: 120,
        },
        {
          name: () => this.$tz("订单,备注"),
          key: "order_remarks",
          minWidth: 110,
        },
        {
          name: () => this.$t("CNBOrder"),
          key: "unpack_order",
          minWidth: 130,
          component: "a",
          methods: {
            click({ row }) {
              this.$page
                .getModal("showCNB")
                .open({ unpack_order: row.unpack_order.split(/\n/g) });
            },
          },
        },
        {
          name: this.$t("operation"),
          type: "btns",
          width: 100,
          fixed: "right",
          list: [
            {
              name: this.$t("rate"),
              type: "rate",
              fnName: "rate",
              bind: {
                type: "warning",
              },
              disabled({ row }) {
                return row.status == 4 || row.status == 8 || row.status == 9;
              },
              // id: 594,
            },
            {
              name: () => this.$t("bindFreight"),
              type: "freight",
              fnName: "freight",
              bind: {
                type: "error",
              },
              afterIcon({ row }) {
                return (row.target_type == 2
                  ? row.branchFinancialTime > 0
                  : row.financeTime) > 0
                  ? "md-checkbox"
                  : "ios-square";
              },
            },
            {
              name: this.$t("BillPreview"),
              type: "preview",
              fnName: "preview",
              bind: {
                type: "primary",
              },
              // id: 594,
            },
            // {
            //   name: () => this.$t("unpack") + this.$t("information"),
            //   type: "unpackmsg",
            //   fnName: "unpackmsgFn",
            //   bind: {
            //     type: "success"
            //   },
            //   show({ row }) {
            //     return row.is_unpack == "YES";
            //   }
            // }
          ],
          methods: {
            rate({ row }) {
              this.handleRequestMethods("getRate", row.id).then((res) => {
                console.log(res, "res");
                let rules = {
                  USD: [],
                  CNY: [],
                  SAR: [],
                  AED: [],
                  QAR: [],
                  KWD: [],
                };
                if (!Array.isArray(res.payload.curren_amount)) {
                  Object.keys(res.payload.curren_amount).map(
                    (t) =>
                      (rules[t] = [
                        {
                          required: true,
                          type: "number",
                          message: "cannot be empty",
                          trigger: "blur",
                        },
                        {
                          required: true,
                          type: "number",
                          message: "cannot less than 0.0001",
                          trigger: "blur",
                          min: 0.0001,
                          max: 999999,
                        },
                      ])
                  );
                }
                Object.assign(this.modals.rate.config.rules || {}, rules);
                this.getModal("rate").open(
                  { ...res.payload.rate, id: row.id },
                  function () {
                    this.setTitle(
                      row.airway_bill_number +
                        "(" +
                        this.$t("BillPreview") +
                        ")"
                    );
                  }
                );
              });
            },
            freight({ row }) {
              row.airway_number = row.airway_bill_number;
              this.getModal("showFreight").open({ row }, function () {
                this.setTitle(
                  row.airway_number + "(" + this.$t("bindFreight") + ")"
                );
              });
            },
            preview({ row }) {
              this.handleRequestMethods("preview", row.airway_bill_number).then(
                (res) => {
                  console.log("res", res);
                  this.getModal("bill").open({}, function () {
                    this.setTitle(
                      row.airway_bill_number +
                        "(" +
                        this.$t("bindFreight") +
                        ")"
                    );
                    this.list = res.payload["airway_number"]
                      ? [res.payload]
                      : [];
                  });
                }
              );
            },
            // unpackmsgFn({ row }) {
            //   this.getModal("showUnPack").open(null, function() {
            //     this.setTitle(
            //       row.airway_bill_number +
            //         this.$t("unpack") +
            //         this.$t("information")
            //     );
            //     this.pageConfig.data = {
            //       airway_number: row.airway_bill_number
            //     };
            //     this.getList();
            //   });
            // }
          },
        },
      ],
    };
  },
};
</script>
